module.exports = __webpack_public_path__ + "img/follow.fcd5c496.png";